import { useCallback } from "react";

import { sendAnalyticsEvent } from "@common/analytics/ga4";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";

export const useAnalytics = () => {
  const { selectedWorkspace } = useAppSelectionContext();

  const sendEvent = useCallback(
    (eventName: string, params?: Record<string, unknown>) => {
      sendAnalyticsEvent(eventName, {
        workspace_id: selectedWorkspace?.id,
        ...params,
      });
    },
    [selectedWorkspace?.id],
  );

  return { sendEvent };
};
